import React, { useEffect, useCallback, useRef } from 'react'
import { BrowserMultiFormatReader } from '@zxing/library'
import Webcam from 'react-webcam'
import { Box } from '@material-ui/core'

const BarcodeScannerComponent = ({ width, height, onUpdate, noCamera, setNoCamera }) => {
   const webcamRef = useRef(null)

   const capture = useCallback(() => {
      const codeReader = new BrowserMultiFormatReader()

      const imageSrc = webcamRef?.current?.getScreenshot()
      if (imageSrc) {
         codeReader
            .decodeFromImage(undefined, imageSrc)
            .then(result => {
               onUpdate(null, result)
            })
            .catch(err => {
               onUpdate(err)
            })
      }
   }, [onUpdate])

   useEffect(() => {
      let interval
      clearInterval(interval)

      interval = setInterval(capture, 10)
   }, [capture])

   return (
      <>
         <Webcam
            style={{
               borderRadius: '10px',
               boxShadow: noCamera === false ? '0px 0px 10px 0px rgba(0, 0, 0, 0.75)' : 0
            }}
            width={width}
            // height={height}
            ref={webcamRef}
            screenshotFormat='image/jpeg'
            videoConstraints={{
               facingMode: 'environment'
            }}
            onUserMediaError={() => setNoCamera(true)}
         />
         {!noCamera ? (
            <Box
               component='div'
               sx={{
                  zIndex: 2,
                  position: 'absolute',
                  borderStyle: 'solid',
                  borderRadius: '10px',
                  borderColor: 'rgba(0, 0, 0, 0.7)',
                  width: '90vw',
                  height: '300px',
                  justifyContent: 'center',
                  borderLeftWidth: '20px',
                  borderRightWidth: '20px',
                  borderTopWidth: '50px',
                  borderBottomWidth: '50px'
               }}
            ></Box>
         ) : (
            <></>
         )}
      </>
   )
}

export default BarcodeScannerComponent
